import { ButtonPrimeReact, PrimeReactModal } from "@finanedi.es/storybook"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useEtiquetasEmpresa } from "api/Etiqueta.hook"
import { MODAL_STYLES } from "constants/primereactStyles"
import { useTranslation } from "react-i18next"
import { InfoModalProps } from "../CategoryManagement"
import EditCreateCategoryForm from "./CategoryForm"

interface CrearCategoriaModalProps {
  visible: boolean
  handleCloseModal: () => void
  infoModal: InfoModalProps
}

const CategoryModal = ({
  visible,
  handleCloseModal,
  infoModal,
}: CrearCategoriaModalProps) => {
  const { t } = useTranslation()

  const {
    addEtiquetaEmpresa,
    etiquetasEmpresaIsLoadingAdd,
    updateEtiquetaEmpresa,
    etiquetasEmpresaIsLoadingUpdate,
  } = useEtiquetasEmpresa()

  return (
    <div>
      <PrimeReactModal
        visible={visible}
        className='tw-w-128 tw-rounded-lg tw-py-5 tw-px-6 tw-bg-white'
        ptContext={MODAL_STYLES}
        closable={false}
        keepInViewport={false}
        baseZIndex={20}
        header={
          <div className='tw-flex tw-justify-between tw-items-center tw-mb-6 '>
            <p className='tw-text-2xl tw-font-medium tw-text-primary tw-m-0'>
              {infoModal.isEdit
                ? t("categoryManagement.modal.headerEdit")
                : t("categoryManagement.modal.header")}
            </p>
            <ButtonPrimeReact
              className='!tw-p-0 !tw-min-w-0 !tw-bg-white !tw-border-none !tw-text-black'
              onClick={handleCloseModal}
            >
              <FontAwesomeIcon
                icon={["fal", "xmark"]}
                className='tw-w-5 tw-h-5'
              />
            </ButtonPrimeReact>
          </div>
        }
        footer={[
          <EditCreateCategoryForm
            key='categoryForm'
            infoModal={infoModal}
            handleCloseModal={handleCloseModal}
            addEditEtiquetaEmpresa={
              infoModal.isEdit ? updateEtiquetaEmpresa : addEtiquetaEmpresa
            }
            isLoading={
              etiquetasEmpresaIsLoadingAdd || etiquetasEmpresaIsLoadingUpdate
            }
            t={t}
          />,
        ]}
      />
    </div>
  )
}

export default CategoryModal
